import { render, staticRenderFns } from "./claimBlackListTip.vue?vue&type=template&id=5e54ea62&scoped=true&"
import script from "./claimBlackListTip.vue?vue&type=script&lang=js&"
export * from "./claimBlackListTip.vue?vue&type=script&lang=js&"
import style0 from "./claimBlackListTip.vue?vue&type=style&index=0&id=5e54ea62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54ea62",
  null
  
)

export default component.exports